import { ElementType, forwardRef } from 'react';
import * as RadixAccordion from '@radix-ui/react-accordion';

import { FlexBox } from '../flex-box';
import { ChevronDownIcon } from '../icon/icons';

import { disclosureStyles } from './disclosure.styles';

type DisclosureProps = React.PropsWithChildren<{
    content?: ElementType | React.ReactNode;
    expanded?: boolean;
    id: string;
    asChild?: boolean;
    onValueChange?: RadixAccordion.AccordionSingleProps['onValueChange'];
}>;

const Disclosure = forwardRef<HTMLButtonElement, DisclosureProps>(
    ({ children, id, asChild, expanded, content: Content, ...rest }, ref) => {
        const { base, toggleIcon } = disclosureStyles();
        return (
            <RadixAccordion.Root collapsible type="single" {...rest} defaultValue={expanded ? id : undefined}>
                <RadixAccordion.Item value={id} asChild={asChild}>
                    <FlexBox gap="sm" alignItems="center">
                        {children}
                        <RadixAccordion.Trigger asChild ref={ref}>
                            <button className={base()}>
                                <ChevronDownIcon className={toggleIcon()} />
                            </button>
                        </RadixAccordion.Trigger>
                    </FlexBox>
                    <RadixAccordion.Content>
                        {typeof Content === 'function' ? <Content /> : Content}
                    </RadixAccordion.Content>
                </RadixAccordion.Item>
            </RadixAccordion.Root>
        );
    },
);

Disclosure.displayName = 'Disclosure';

export type { DisclosureProps };
export { Disclosure };
